import { motion } from "framer-motion";

export const Footer = () => (
  <footer className="relative" data-testid="site-footer">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-24 md:py-32 grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.94 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
        className="md:col-span-4"
      >
        <img
          src="/assets/logo.jpg"
          alt="RayStance Eyewear — gold RS monogram on black marble"
          className="w-40 md:w-52 border border-gold/20"
          data-testid="footer-logo"
        />
      </motion.div>
      <div className="md:col-span-8 md:text-right">
        <p className="font-serif italic font-light text-3xl md:text-5xl leading-tight text-white">
          It's your perspective. It's your story.
          <br />
          <span className="gold-text-gradient">It's your stance.</span>
        </p>
        <p className="mt-10 text-xs uppercase tracking-[0.3em] text-ash">
          © {new Date().getFullYear()} RayStance Eyewear — All rights reserved
        </p>
      </div>
    </div>
  </footer>
);
